import { useContext } from "react";
import AgGridLayout from "@wrappers/layouts/AgGridLayout";
import { onSelectionChangedKeywordRecommendations, titleCase } from "@ts/utils";
import { customFilterOptions, mainContext } from "@ts/constants";
import {
    UpdateKeywordManualBid,
} from "@cell-renderers/AllCellRenderers";
import { useSelector } from "react-redux";
import { IMainContext, IRecommendationsData } from "@ts/common-types";
import { useGetModulesData } from "@hooks/AllCustomHooks";
import { ValueFormatterParams } from "ag-grid-community";

const RevinitiRecommendations = () => {
    const {
        setRevinitiRecommendationsGridApi,
        revinitiRecommendationsLoading,
    } = useContext<IMainContext>(mainContext);

    const columnDefs = useGetModulesData({
        type: "columns",
        colDefs: [
            {
                field: "search_term",
                headerName: "Search Term",
                minWidth: 300,
                maxWidth: 450,
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: customFilterOptions["text"],
                },
                checkboxSelection: true,
                pinned: "left",
                lockPinned: true,
                cellClass: "lock-pinned",
                tooltipField: "custom_search_term",
                valueFormatter: (params: ValueFormatterParams) =>
                    titleCase(params.value || ""),
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
            },
            {
                field: "bid",
                headerName: "Recommended Bid",
                maxWidth: 200,
                minWidth: 180,
                lockPinned: true,
                cellClass: "lock-pinned",
                cellRenderer: UpdateKeywordManualBid,
                cellRendererParams: {
                    hasPinnedColumnValue: false,
                },
                filter: "agNumberColumnFilter",
                filterParams: {
                    filterOptions: customFilterOptions["numberWithoutChanges"],
                },
            },
            {
                field: "adgroup_name",
                headerName: "Ad Group",
                filter: "agTextColumnFilter",
            },
            {
                field: "campaign_name",
                headerName: "Campaign",
                filter: "agTextColumnFilter",
            },
            {
                field: "targeting_class",
                headerName: "Targeting Class",
                // filter: "agTextColumnFilter",
                valueFormatter: (params: ValueFormatterParams) => params.value ? titleCase(params.value) : '',
            },
        ],
    });

    const revinitiRecommendationData = useSelector(
        (state: IRecommendationsData) => state.revinitiRecommendationData.value
    );

    return (
        <div className="wrapper" style={{ flex: "1 1 0" }}>
            <div
                id="reviniti-grid"
                className="ag-theme-alpine"
                style={{ height: "98%", width: "100%" }}
            >
                <AgGridLayout
                    rowData={revinitiRecommendationData}
                    columnDefs={columnDefs}
                    setGridApi={setRevinitiRecommendationsGridApi}
                    onSelectionChanged={
                        onSelectionChangedKeywordRecommendations
                    }
                    loading={revinitiRecommendationsLoading}
                    isTotalRowsReq={true}
                />
            </div>
        </div>
    );
};

export default RevinitiRecommendations;
